import { createContext } from 'react';
import type {
  CurrentUser,
  LoginInput,
  RegisterInput,
} from '../models/auth.types';

export interface AuthContextValue {
  user: CurrentUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  login: (input: LoginInput) => Promise<CurrentUser>;
  register: (input: RegisterInput) => Promise<CurrentUser>;
  logout: () => Promise<void>;
  /** Re-fetch the authenticated user (e.g. after a self-service profile edit). */
  refreshUser: () => Promise<void>;
  clearError: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
